/**
 * @module sagas/ExternalApi.js
 *
 * This file replaces our ActionRouter and currently calls our Promised based
 * middleware workflow functions. Eventually, all Workflows and ActionCreators
 * should themselves be Sagas.
 */
import { all, take } from 'redux-saga/effects';

import { onExternalApiCall } from '../actions/workflows/ExternalApi/ExternalApi';
import actions from '../constants/External';
import { getStore } from '../store/StoreAccessor';

import { taskManagerSpawnFactory } from './Helpers/SpawnedTaskManager';

const spawn = taskManagerSpawnFactory();
const LOOP = true;

/**
 * Watch for RELAY_EXTERNAL_API_CALL and execute onExternalApiCall workflow
 *
 * @param {object} router - the routing object
 */
export function* watchRelayExternalApiCall() {
  while (LOOP) {
    const action = yield take(actions.RELAY_EXTERNAL_API_CALL);
    yield spawn(onExternalApiCall, action, getStore());
  }
}

/**
 * Root ExternalApi Saga
 *
 * @param {object} router - the routing object
 */
export default function* externalApiSaga() {
  yield all([spawn(watchRelayExternalApiCall)]);
}
